import React from 'react';
import styles from './NoReportsMessage.module.scss';
import { SFText } from 'sfui';

export const NoReportsMessage = () => {
  return (
    <SFText type="component-2" className={styles.noReportsMessage}>
      There are no reports associated with this project yet.
    </SFText>
  );
};
